export default __webpack_public_path__ + "static/media/MyEvent_Pickup.3cb97618.svg";